import pos1 from 'assets/icons/positions/pos-1.png'
import pos2 from 'assets/icons/positions/pos-2.png'
import pos3 from 'assets/icons/positions/pos-3.png'
import pos4 from 'assets/icons/positions/pos-4.png'
import pos5 from 'assets/icons/positions/pos-5.png'
import pos6 from 'assets/icons/positions/pos-6.png'
import pos7 from 'assets/icons/positions/pos-7.png'
import pos8 from 'assets/icons/positions/pos-8.png'
import pos9 from 'assets/icons/positions/pos-9.png'
import pos10 from 'assets/icons/positions/pos-10.png'
import pos11 from 'assets/icons/positions/pos-11.png'
import pos12 from 'assets/icons/positions/pos-12.png'

// Types
import { Option } from 'common/types'
import { HeadCell, TagCategory } from './CardView.types'

export const skinPreps = [
  {
    id: 'betadine5',
    name: 'Betadine 5%',
  },
  {
    id: 'betadine10',
    name: 'Betadine 10%',
  },
  {
    id: 'dilutedBetadine',
    name: 'Diluted Betadine',
  },
  {
    id: 'chloraPrep',
    name: 'Chloraprep',
  },
  {
    id: 'chlorhexidine',
    name: 'Chlorhexidine',
  },
  {
    id: 'PCMX',
    name: '3% PCMX',
  },
]

export const positioningDevices = [
  {
    id: 'gelDonut',
    name: 'Gel Donut',
  },
  {
    id: 'gelRolls',
    name: 'Gel Rolls',
  },
  {
    id: 'other',
    name: 'Others',
  },
]

export const packsOptions: Option[] = [
  { id: 'General', name: 'General' },
  { id: 'ECMO', name: 'ECMO' },
  { id: 'Mini', name: 'Mini' },
  { id: 'Cystoscopy', name: 'Cystoscopy' },
  { id: 'Cataract', name: 'Cataract' },
  { id: 'Eye', name: 'Eye' },
  { id: 'Craniotomy', name: 'Craniotomy' },
  { id: 'VP shunt', name: 'VP shunt' },
  { id: 'L and B', name: 'L and B' },
  { id: 'T and A', name: 'T and A' },
  { id: 'Mastoid', name: 'Mastoid' },
  { id: 'ENT', name: 'ENT' },
  { id: 'Spine', name: 'Spine' },
  { id: 'Major Ortho', name: 'Major Ortho' },
  { id: 'Plastics', name: 'Plastics' },
  { id: 'Heart', name: 'Heart' },
]

export const drillOptions = [
  { id: 'Stryker cordless driver', name: 'Stryker cordless driver' },
  { id: 'Stryker system 8', name: 'Stryker system 8' },
  { id: 'Stryker MicroAirpower', name: 'Stryker MicroAirpower' },
  { id: 'Stryker TPS', name: 'Stryker TPS' },
  { id: 'Stryker CD4', name: 'Stryker CD4' },
  { id: 'Midas Rex (pneumatic)', name: 'Midas Rex (pneumatic)' },
]

export const positions: { image: string; name: string }[] = [
  {
    image: pos1,
    name: 'Supine',
  },
  {
    image: pos2,
    name: 'Trendelenburg',
  },
  {
    image: pos3,
    name: 'Reverse Trendelenburg',
  },
  {
    image: pos4,
    name: 'Fracture Table',
  },
  {
    image: pos5,
    name: 'Lithotomy',
  },
  {
    image: pos6,
    name: 'Prone',
  },
  {
    image: pos7,
    name: 'Jackknife',
  },
  {
    image: pos8,
    name: "Fowler's",
  },
  {
    image: pos9,
    name: 'Knee-Chest',
  },
  {
    image: pos10,
    name: 'Kidney',
  },
  {
    image: pos11,
    name: 'Lateral',
  },
  {
    image: pos12,
    name: 'Wilson Frame',
  },
]

export const defaultTags: TagCategory[] = [
  'Pack',
  'Gloves',
  'Drapes',
  'Sutures',
  'General Supply',
  'Dressings',
  'Medications',
]

export const consumablesTableHeaders: HeadCell[] = [
  {
    id: 'description',
    label: 'Description',
    numeric: true,
  },
  {
    id: 'catalogNumber',
    label: 'Catalog Number',
    numeric: true,
  },
  {
    id: 'modelNumber',
    label: 'Model Number',
    numeric: true,
  },
  {
    id: 'tags',
    label: 'Tags',
    numeric: true,
  },
  {
    id: 'actions',
    label: 'ACTIONS',
    numeric: true,
  },
]

export const pascInstrumentTrayOptions: string[] = [
  '5mm 0&30 degree',
  'Anal scope',
  'Arthrex 30-degree scope',
  'Arthrex ACL trays',
  'Arthrex ankle 30 degree 2.7mm scope',
  'Arthrex ankle Distractor',
  'Arthrex Bio-Tenodesis tray',
  'Arthrex camera and light cord',
  'Arthrex Chondro Picks',
  'Arthrex graft prep station set',
  'Arthrex graspers',
  'Arthrex lightcord',
  'Arthrex Retro reconstruction tray',
  'Arthrex shoulder tray',
  'Arthrex video camera',
  'Arthroscopy/laparoscopy 4mm 30-degree scope',
  'Atlantech Graspers',
  'Bariatric graspers',
  'Basin',
  'Batteries',
  'BIOM tray',
  'Bleph',
  'Boogie',
  'Breast bowls',
  'Breast sizers',
  'Breast Tray',
  'Cataract black light handles',
  'Cataract trays',
  'Compaction plier set',
  'Cordless driver',
  'Coupler',
  'Curette set',
  'Cysto tray',
  'D & C Tray',
  'D&C suction tubing',
  'Dilators',
  'Dissecting Tray',
  'Drill bit set',
  'Essure instruments',
  'Face cannulas',
  'Face lift',
  'Fat transfer',
  'Fat transfer cannister',
  'Finger traps',
  'Glass fat transfer cannister',
  'GYN ACMI Hysteroscope',
  'GYN Lap Tray',
  'Hemorriodectomy Tray',
  'Kaiser cataract trays',
  'Kaiser rhino inst',
  'Kaiser surgery tray',
  'Kidney Basins',
  'KLS small hardware removal set',
  'K-wires',
  'Lap Chole Tray',
  'Laparoscopic scissors',
  'Laparoscopy trocars',
  'Lead hand',
  'Light Handles',
  'Lighted retractor',
  'Lipo cord',
  'Lipo&fat transfer',
  'Liver retractor',
  'Laryngoscope handles',
  'Lonestar',
  'Magnet pads',
  'Major Tray',
  'Mallet',
  'Medtronic shaver',
  'Micro instruments',
  'MicroAire power',
  'Mini mandiblualar Tray',
  'Minor Tray',
  'Myringotomy Tray',
  'Oconno Sullivan/blades',
  'Olympus 70-degree',
  'Operative Laparoscopy Tray',
  'Ora cover',
  'Orthro Minor Amputation',
  'Osteotomes',
  'Otoplasty',
  'Plastic Tray',
  'Podiatry Tray',
  'Retina resight',
  'Rhinoplasty Tray',
  'Rhizotomy',
  'Rosa partial and total trays',
  'S&N spider inst',
  'Scope adapters',
  'Septal Nasal Tray',
  'Sigmoid scope',
  'Small bowls',
  'Smith and nephew Dyonics power',
  'Smith and Nephew hip arthroscopy repair tray',
  'Spine drill',
  'Storz & wolf 4mm 30&70 degree',
  'Stryker 4mm 70 degrees',
  'Stryker 5mm 0-degree scope',
  'Stryker hysteroscopy set',
  'Stryker implant extraction set',
  'Stryker laparoscopic instrument bin',
  'Stryker laparoscopic tray',
  'Stryker meniscal repair tray',
  'Stryker microdebrider',
  'Stryker saber drill',
  'Stryker shaver',
  'Stryker small joint instrument set',
  'Stryker small joint scope',
  'Stryker suction irrigation tips',
  'System 6',
  'T & A Adult',
  'T & A Peds',
  'T.T.',
  'Teeth guard',
  'Total knee Tray',
  'Trimano coupler',
  'True clear',
  'Tubal Tray',
  'Vitrectomy tray',
  'Wolf 10mm 90-degree',
  'Wolf 17 and 13inch uretero-reno',
  'Wolf 2.7mm 30 degree/entellus 3.0m',
  'Wolf 4mm 0 degree',
  'Wolf 5mm 0&30degree',
  'Wolf 90-degree scope',
  'Wolf flexible fiberscope',
  'Zimmer patella femoral joint system',
  'Zimmer PKK set',
]

export const instrumentTrayOptions: string[] = [
  'Basic',
  'Burn',
  'Basic Urology',
  'Craniotomy',
  'Special Plastic',
  'Ortho Basic',
  'GYN',
  'Midface',
  'Basic General',
  'Spine',
  'Cardiac',
  'Mandible',
  'Laparotomy',
  'Ortho Fx',
  'ENT',
  'Bookwalter',
  'Neurosurgery',
  'Vascular',
  'Thoracic',
  'Trauma',
  'Pediatric',
  'Hand',
  'Foot & Ankle',
  'Shoulder',
  'Hip',
  'Knee',
]

export const medicationOptions = [
  { id: 'NASAL_DECOG', name: '12 HOUR NASAL DECOG 0.05% SPY 30 ML' },
  { id: 'ACETAMINOPHEN_325_TAB', name: 'ACETAMINOPHEN 325 MG TAB 100' },
  { id: 'ACETAMINOPHEN_325_TAB_UD', name: 'ACETAMINOPHEN 325 MG TAB 100 UD' },
  {
    id: 'ACETAMINOPHEN_IV',
    name: 'ACETAMINOPHEN IV 10 MG/ML SDV 24X100 ML (OFIRMEV)',
  },
  { id: 'ACETAZOLAMIDE', name: 'ACETAZOLAMIDE 500 MG SDV (EXP 09/25)' },
  { id: 'ADENOSINE', name: 'ADENOSINE 3 MG/ML SDV 10X2 ML PF' },
  { id: 'ALBUTEROL', name: 'ALBUTEROL HFA 90 MCG INHALER 8 GM (VENTOLIN)' },
  { id: 'AMIODARONE', name: 'AMIODARONE 50 MG/ML SDV 25X3 ML' },
  { id: 'ASPIRIN', name: 'ASPIRIN 325 MG EC TAB 100' },
  { id: 'ASTHMANEFRIN', name: 'ASTHMANEFRIN 2.25% 11.25 MG RFIL VL 30X0.5 ML' },
  { id: 'ATROPINE_OPH', name: 'ATROPINE 1% OPH SOL 2 ML' },
  { id: 'ATROPINE_SULFATE', name: 'ATROPINE SULFATE 1% O/S 2 ML' },
  { id: 'BACITRACIN', name: 'BACITRACIN 500 UN/GM ONT 28.4 GM' },
  { id: 'BETAMETHASONE', name: 'BETAMETHASONE (CELESTONE) 6 MG/ML MDV 5 ML' },
  { id: 'BUPIVACAINE', name: 'BUPIVACAINE 0.25% (2.5 MG/ML) SDV 10X10 ML PF' },
  { id: 'CEFAZOLIN', name: 'CEFAZOLIN 1 GM VL 25' },
  { id: 'CEFTRIAXONE', name: 'CEFTRIAXONE 1 GM VL 10' },
  { id: 'CETACAINE', name: 'CETACAINE SPY 5 GM' },
  { id: 'CHLORHEXIDINE', name: 'CHLORHEXIDINE GLUCONATE 0.12% LIQ 118 ML' },
  { id: 'CIPROFLOXACIN', name: 'CIPROFLOXACIN 0.3% OPH SOL 2.5 ML' },
  { id: 'CLINDAMYCIN', name: 'CLINDAMYCIN 150 MG/ML SDV 25X2 ML' },
  { id: 'CYCLOPENTOLATE_15ML', name: 'CYCLOPENTOLATE 1% OPH SOL 15 ML' },
  { id: 'CYCLOPENTOLATE_2ML', name: 'CYCLOPENTOLATE 1% OPH SOL 2 ML' },
  { id: 'DEXAMETHASONE', name: 'DEXAMETHASONE 10 MG/ML SDV 25X1 ML' },
  { id: 'DIGOXIN', name: 'DIGOXIN 500 MCG AMP 25X2 ML' },
  { id: 'DIPHENHYDRAMINE', name: 'DIPHENHYDRAMINE 50 MG/ML SDV 25X1 ML' },
  { id: 'DOBUTAMINE', name: 'DOBUTAMINE 250 MG SDV 10X20 ML' },
  { id: 'DOPAMINE', name: 'DOPAMINE-DEXT 400 MG IV BAG 12X250 ML' },
  { id: 'DOUBLE_ANTIBIOTIC', name: 'DOUBLE ANTIBIOTIC OINTMENT 1 OZ' },
  { id: 'EPHEDRINE_5MG', name: 'EPHEDRINE 5 MG/ML SDV 10 ML' },
  { id: 'EPHEDRINE_50MG_10X1', name: 'EPHEDRINE 50 MG/ML SDV 10X1 ML' },
  { id: 'EPHEDRINE_50MG_25X1', name: 'EPHEDRINE 50 MG/ML SDV 25X1 ML' },
  { id: 'EPHEDRINE_SULFATE', name: 'EPHEDRINE SULFATE 50 MG SDV 10X1 ML' },
  {
    id: 'EPINEPHRINE_1_1000',
    name: 'EPINEPHRINE (1:1000) 1 MG/ML AMP 10X1 ML PF',
  },
  {
    id: 'EPINEPHRINE_1_1000_MDV',
    name: 'EPINEPHRINE (1:1000) 1 MG/ML MDV 30 ML',
  },
  {
    id: 'EPINEPHRINE_1_10000',
    name: 'EPINEPHRINE (1:10000) 0.1 MG/ML SYG 10X10 ML',
  },
  { id: 'ERYTHROMYCIN', name: 'ERYTHROMYCIN 0.5% OPH ONT 3.5 GM' },
  { id: 'ESMOLOL', name: 'ESMOLOL 10 MG/ML SDV 25X10 ML' },
  { id: 'FAMOTIDINE', name: 'FAMOTIDINE 10 MG/ML SDV 25X2 ML' },
  { id: 'FLUMAZENIL', name: 'FLUMAZENIL 0.1 MG/ML MDV 10X5 ML' },
  { id: 'FLURBIPROFEN', name: 'FLURBIPROFEN 0.03% OPH SOL 2.5 ML' },
  { id: 'FUROSEMIDE_10X4', name: 'FUROSEMIDE 10 MG/ML SDV 10X4 ML' },
  { id: 'FUROSEMIDE_25X2_1', name: 'FUROSEMIDE 10 MG/ML SDV 25X2 ML' },
  { id: 'FUROSEMIDE_25X2_2', name: 'FUROSEMIDE 10 MG/ML SDV 25X2 ML' },
  { id: 'FUROSEMIDE_25X4', name: 'FUROSEMIDE 10 MG/ML SDV 25X4 ML' },
  { id: 'GENTAMICIN', name: 'GENTAMICIN 40 MG/ML SDV 25X2 ML' },
  { id: 'GLYCOPYRROLATE', name: 'GLYCOPYRROLATE 0.2 MG/ML SDV 25X1 ML' },
  { id: 'HEPARIN_SODIUM_1ML', name: 'HEPARIN SODIUM 5000 UN MDV 25X1 ML' },
  {
    id: 'HEPARIN_SODIUM_2ML',
    name: 'HEPARIN SODIUM 5000 UN MDV 25X1 ML (2 ML)',
  },
  { id: 'HUMULIN_R_3ML', name: 'HUMULIN R 100 UN/ML MDV 3 ML' },
  { id: 'HUMULIN_R_10ML', name: 'HUMULIN R 100 UN/ML VL 10 ML' },
  { id: 'HYDRALAZINE', name: 'HYDRALAZINE 20 MG/ML SDV 25X1 ML' },
  { id: 'INTRALIPID', name: 'INTRALIPID 20% BAG 6X1000 ML' },
  { id: 'KETOROLAC_IM_IV', name: 'KETOROLAC 30 MG/ML SDV 25X1 ML (IM/IV)' },
  { id: 'KETOROLAC_IM', name: 'KETOROLAC 60 MG/2 ML SDV 25X2 ML (IM)' },
  { id: 'LABETALOL_1', name: 'LABETALOL 5 MG/ML MDV 20 ML' },
  { id: 'LABETALOL_2', name: 'LABETALOL 5 MG/ML MDV 20 ML' },
  { id: 'LIDOCAINE_1_MDV', name: 'LIDOCAINE 1% MDV 10X50 ML' },
  { id: 'LIDOCAINE_1_SDV', name: 'LIDOCAINE 1% SDV 10X5 ML PF' },
  { id: 'LIDOCAINE_2_JELLY', name: 'LIDOCAINE 2% JELLY SYG 25X10 ML' },
  {
    id: 'LIDOCAINE_2_JELLY_GLYDO',
    name: 'LIDOCAINE 2% JELLY SYRINGE 10X6 ML (GLYDO)',
  },
  { id: 'LIDOCAINE_2_MDV', name: 'LIDOCAINE 2% MDV 10X50 ML' },
  { id: 'LIDOCAINE_4_TOP', name: 'LIDOCAINE 4% TOP SOL 50 ML' },
  { id: 'MAGNESIUM_SULFATE', name: 'MAGNESIUM SULFATE 50% SDV 25X10 ML' },
  { id: 'MARCAINE_0.5', name: 'MARCAINE 0.5% MDV 50 ML' },
  {
    id: 'METHYLPREDNISOLONE_1ML',
    name: 'METHYLPREDNISOLONE ACE 40 MG/ML SDV 1 ML (DEPO-MEDROL)',
  },
  {
    id: 'METHYLPREDNISOLONE_25X1ML',
    name: 'METHYLPREDNISOLONE ACE 40 MG/ML SDV 25X1 ML (DEPO-MEDROL)',
  },
  { id: 'METOCLOPRAMIDE', name: 'METOCLOPRAMIDE 5 MG/ML SDV 25X2 ML' },
  { id: 'METOCLOPRAMIDE_PF', name: 'METOCLOPRAMIDE 5 MG/ML SDV 25X2 ML PF' },
  {
    id: 'METOCLOPRAMIDE_PF_EXP',
    name: 'METOCLOPRAMIDE 5 MG/ML SDV 25X2 ML PF (EXP 05/25)',
  },
  { id: 'METOPROLOL_1', name: 'METOPROLOL 1 MG/ML SDV 10X5 ML' },
  { id: 'METOPROLOL_2', name: 'METOPROLOL 1 MG/ML SDV 10X5 ML' },
  { id: 'MIDAZOLAM_MDV', name: 'MIDAZOLAM 1 MG/ML MDV 10X5 ML' },
  { id: 'MIDAZOLAM_SDV_10X5', name: 'MIDAZOLAM 1 MG/ML SDV 10X5 ML PF' },
  { id: 'MIDAZOLAM_SDV_25X2', name: 'MIDAZOLAM 1 MG/ML SDV 25X2 ML PF' },
  { id: 'MISOPROSTOL', name: 'MISOPROSTOL 100 MCG TAB 60' },
  { id: 'NALOXONE_0.4_1', name: 'NALOXONE 0.4 MG/ML SDV 10X1 ML' },
  { id: 'NALOXONE_0.4_2', name: 'NALOXONE 0.4 MG/ML SDV 10X1 ML' },
  { id: 'NALOXONE_1', name: 'NALOXONE 1 MG/ML SYG 10X2 ML' },
  {
    id: 'NEOMYCIN_ONT_1',
    name: 'NEOMYCIN-POLYMYXIN-DEXAMETHASONE OPH ONT 3.5 GM',
  },
  {
    id: 'NEOMYCIN_ONT_2',
    name: 'NEOMYCIN-POLYMYXIN-DEXAMETHASONE OPH ONT 3.5 GM',
  },
  { id: 'NEOMYCIN_SOL', name: 'NEOMYCIN-POLYMYXIN-DEXAMETHASONE OPH SOL 5 ML' },
  { id: 'NEOSTIGMINE', name: 'NEOSTIGMINE 1 MG/ML MDV 10X10 ML' },
  { id: 'NITRO_BID', name: 'NITRO-BID 2 % ONT 30 GM' },
  { id: 'NITROGLYCERIN', name: 'NITROGLYCERIN 0.4MG SL TAB 100' },
  { id: 'NOVOLIN_R', name: 'NOVOLIN R 100 UN/ML VL 10 ML' },
  { id: 'ONDANSETRON_2_1', name: 'ONDANSETRON 2 MG/ML SDV 25X2 ML' },
  { id: 'ONDANSETRON_2_2', name: 'ONDANSETRON 2 MG/ML SDV 25X2 ML' },
  { id: 'ONDANSETRON_4_ODT', name: 'ONDANSETRON 4 MG ODT 30' },
  { id: 'ONDANSETRON_4_ODT_UD', name: 'ONDANSETRON 4 MG ODT 30 UD' },
  { id: 'OXYMETAZOLINE', name: 'OXYMETAZOLINE 0.05% SPRAY 1OZ' },
  { id: 'PHENYLEPHRINE_10_1', name: 'PHENYLEPHRINE 10 MG/ML SDV 25X1 ML' },
  { id: 'PHENYLEPHRINE_10_2', name: 'PHENYLEPHRINE 10 MG/ML SDV 25X1 ML' },
  { id: 'PHENYLEPHRINE_10_OPH', name: 'PHENYLEPHRINE 10% OPH SOL 5 ML' },
  { id: 'PREDNISOLONE', name: 'PREDNISOLONE ACETATE 1% OPH SOL 5 ML' },
  { id: 'PROMETHAZINE_AMP', name: 'PROMETHAZINE 25 MG/ML AMP 25X1 ML' },
  { id: 'PROMETHAZINE_SDV', name: 'PROMETHAZINE 25 MG/ML SDV 25X1 ML' },
  { id: 'PROPOFOL_100ML', name: 'PROPOFOL 10 MG/ML SDV 10X100 ML (EDTA)' },
  { id: 'PROPOFOL_10X20ML', name: 'PROPOFOL 10 MG/ML SDV 10X20 ML (EDTA)' },
  { id: 'PROPOFOL_20X20ML', name: 'PROPOFOL 10 MG/ML SDV 20X20 ML (EDTA)' },
  { id: 'PROPOFOL_20X50ML', name: 'PROPOFOL 10 MG/ML SDV 20X50 ML (EDTA)' },
  {
    id: 'PROPOFOL_BENZYL',
    name: 'PROPOFOL 10 MG/ML SDV 25X20 ML (BENZYL ALC)',
  },
  { id: 'ROCURONIUM_1', name: 'ROCURONIUM 10 MG/ML MDV 10X5 ML' },
  { id: 'ROCURONIUM_2', name: 'ROCURONIUM 10 MG/ML MDV 10X5 ML' },
  { id: 'ROCURONIUM_BROMIDE', name: 'ROCURONIUM BROMIDE 50 MG MDV 10X5 ML' },
  {
    id: 'ROPIVACAINE_10ML',
    name: 'ROPIVACAINE 0.2% SDV 25X10 ML PF (NAROPIN)',
  },
  {
    id: 'ROPIVACAINE_20ML',
    name: 'ROPIVACAINE 0.2% SDV 25X20 ML PF (NAROPIN)',
  },
  { id: 'ROPIVACAINE_HCL', name: 'ROPIVACAINE HCL 2 MG-ML SDV 25X20 ML' },
  { id: 'SENSORCAINE_0.5', name: 'SENSORCAINE 0.5% SDV 25X10 ML PF' },
  { id: 'SENSORCAINE_0.75', name: 'SENSORCAINE 0.75% SDV 25X10 ML PF' },
  { id: 'SEVOFLURANE', name: 'SEVOFLURANE INH BTL 1X250 ML' },
  { id: 'SODIUM_CHLORIDE', name: 'SODIUM CHLORIDE 0.9% SDV 25X10 ML PF' },
  { id: 'SOLU_CORTEF_AOV', name: 'SOLU CORTEF 100 MG AOV 2 ML' },
  { id: 'SOLU_CORTEF_VL', name: 'SOLU CORTEF 100 MG VL' },
  { id: 'STERILE_WATER', name: 'STERILE WATER FOR INJECTION SDV 25X10 ML PF' },
  { id: 'STYE_OINTMENT', name: 'STYE OINTMENT 0.125OZ' },
  { id: 'SUCCINYLCHOLINE_1', name: 'SUCCINYLCHOLINE 20 MG/ML MDV 25X10 ML' },
  { id: 'SUCCINYLCHOLINE_2', name: 'SUCCINYLCHOLINE 20 MG/ML MDV 25X10 ML' },
  { id: 'TRANEXAMIC_ACID_1', name: 'TRANEXAMIC ACID 100 MG/ML SDV 10X10 ML' },
  { id: 'TRANEXAMIC_ACID_2', name: 'TRANEXAMIC ACID 100 MG/ML SDV 10X10 ML' },
  {
    id: 'TRANSDERM_SCOPOLAMINE_10',
    name: 'TRANSDERM SCOPOLAMINE 1 MG (3 DAY) PATCH BX/10',
  },
  {
    id: 'TRANSDERM_SCOPOLAMINE_4',
    name: 'TRANSDERM SCOPOLAMINE 1 MG (3 DAY) PATCH BX/4',
  },
  {
    id: 'TRIAMCINOLONE',
    name: 'TRIAMCINOLONE ACE 40 MG/ML SDV 25X1 ML (KENALOG)',
  },
  { id: 'TRIPLE_ANTIBIOTIC_1OZ', name: 'TRIPLE ANTIBIOTIC OINTMENT 1 OZ' },
  { id: 'TRIPLE_ANTIBIOTIC_UD', name: 'TRIPLE ANTIBIOTIC ONT 144X.9 GM UD' },
  { id: 'TROPICAMIDE', name: 'TROPICAMIDE 1% OPH SOL 15 ML' },
  { id: 'TYLENOL_CHILD', name: 'TYLENOL CHILD SUSPENSION GRAPE LIQ 120ML' },
  { id: 'VANCOMYCIN_1GM_1', name: 'VANCOMYCIN 1 GM VL 10' },
  { id: 'VANCOMYCIN_1GM_2', name: 'VANCOMYCIN 1 GM VL 10' },
  { id: 'VANCOMYCIN_500MG', name: 'VANCOMYCIN 500 MG VL 10' },
  { id: 'VECURONIUM', name: 'VECURONIUM 10 MG VL 10' },
]
